/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  _initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  return {
    /** 当前用户信息仅含 nickname，管理员权限需后端字段后再接入 */
    canAdmin: false,
  };
}
